import '../../assets/beautrium-css/components/coupon.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { moneyFormat } from '../../assets/util';
import moment from 'moment';
import { withRouter } from 'react-router-dom'
import { collectCoupon, storeCouponAuth, setCouponListDisplay } from '../../actions/coupon';
import { swal, close } from 'react-redux-sweetalert'
import { DELIVERY_COST } from '../../config';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'

class CouponCard extends Component {

    constructor(props) {
        super(props)

        this.handleCollectCoupon = this.handleCollectCoupon.bind(this)
        this.onClickOption = this.onClickOption.bind(this)
        this.renderButtonText = this.renderButtonText.bind(this)
    }

    componentDidUpdate(prevProps) {
        const listener = typeof this.props.listener !== "undefined" ? this.props.listener : true;
        if (listener) {
            if (prevProps.collect_coupon === false && this.props.collect_coupon) {
                const { collect_coupon } = this.props
                this.props.swal({
                    type: collect_coupon.type,
                    title: collect_coupon.title,
                    text: collect_coupon.text,
                    onConfirm: () => {
                        this.props.close();
                        if (typeof this.props.onSuccessCollected === "function") {
                            this.props.onSuccessCollected();
                        }
                    },
                    customClass: 'bt-dialog-box',
                });
            }
        }
    }

    handleCollectCoupon(coupon) {
        if (this.props.authenticated) {
            this.props.collectCoupon(this.props.profile.user_id, coupon.id)
        } else {
            const { onFailedCollected } = this.props
            this.props.storeCouponAuth(coupon)
            if (typeof onFailedCollected === "function") {
                onFailedCollected()
            } else {
                this.props.history.push('/login')
            }
        }
    }

    getCollectedStatus(coupon) {
        return coupon ? coupon.collected_status : null
    }

    onClickOption(coupon) {
        const { needAuth, useCoupon } = this.props
        const collected = this.getCollectedStatus(coupon) || !this.isCouponStarted(coupon) || this.isCouponExpired(coupon) || coupon.collectable === false || (coupon.pickup_quantity && coupon.picked_quantity >= coupon.pickup_quantity) || coupon.remain === 0 || needAuth
        if ((this.props.selectCoupon && typeof this.props.selectCoupon === "function") && useCoupon) {
            this.props.selectCoupon(coupon.promo_code)
            this.props.setCouponListDisplay(false)
        } else if (!collected && !needAuth) {
            this.handleCollectCoupon(coupon)
        }
    }

    isCouponStarted(coupon) {
        const now = moment();
        return moment(coupon.start_date).isSameOrBefore(now, 's') || (moment(coupon.pickup_start_date).isValid() && moment(coupon.pickup_start_date).isSameOrBefore(now, 's'));
    }

    isCouponExpired(coupon) {
        const now = moment();
        return moment(coupon.end_date).isBefore(now, 's')
    }

    renderButtonText(coupon) {
        const { needAuth, useCoupon, authenticated } = this.props
        const isCouponStarted = this.isCouponStarted(coupon)
        const isCouponExpired = this.isCouponExpired(coupon)
        const collected = this.getCollectedStatus(coupon)
        const diff = moment().diff(coupon.pickup_start_date, 'h');
        const userRound = Math.floor(diff / coupon.pickup_interval);
        const lastTimeRound = Math.floor(moment(coupon.picked_lasttime).diff(coupon.pickup_start_date, 'h', true) / coupon.pickup_interval);
        let text = ''
        if (coupon.remain === 0) {
            text = 'สิทธิครบแล้ว'
        } else if (useCoupon) {
            text = 'ใช้คูปอง'
        } else if (userRound === lastTimeRound && coupon.pickup_quantity_interval && coupon.pickup_quantity_interval <= coupon.picked_quantity_interval) {
            text = 'รอบนี้หมดแล้ว'
        } else if (coupon.pickup_quantity && coupon.pickup_quantity <= coupon.picked_quantity) {
            text = 'หมด'
        } else if (coupon.pickup_start_date && moment(coupon.pickup_start_date).isAfter(moment(), 's')) {
            text = 'ไม่ใช่ช่วงเวลา'
            // text = `เริ่ม ${moment(coupon.pickup_start_date).format("DD/MM/YYYY")}`
        } else if (!coupon.pickup_start_date && !isCouponStarted) {
            text = 'ไม่ใช่ช่วงเวลา'
            // text = `เริ่ม ${moment(coupon.start_date).format("DD/MM/YYYY")}`
        } else if (isCouponExpired) {
            text = 'หมดอายุ'
        } else if (needAuth) {
            text = 'เฉพาะสมาชิก'
        } else if (authenticated) {
            if (collected) {
                text = 'เก็บแล้ว'
            } else if (coupon.collectable === false) {
                if (coupon.new_user === 1) {
                    text = 'เฉพาะลูกค้าใหม่'
                } else {
                    text = 'ไม่สามารถเก็บได้'
                }
            } else {
                text = 'เก็บ'
            }
        } else {
            text = 'เก็บ'
        }
        return text
    }

    render() {
        const { coupon, needAuth } = this.props //attraction, useCoupon, isUsed, simpleDesign
        if (!coupon) {
            return null
        }
        const collected = !this.isCouponStarted(coupon) || this.isCouponExpired(coupon) || coupon.collectable === false || coupon.remain === 0 || needAuth
        // const customHolder = this.props.customHolder ? this.props.customHolder : {}
        // const customCoupon = this.props.customCoupon ? this.props.customCoupon : {}
        // const simpleDesignStyle = simpleDesign? {height: "141px", backgroundColor: "transparent"}: {}
        return (
            <div className="coupon-v2-container mx-auto">
                <div className="coupon-shadow"></div>
                <div className="coupon-v2" onClick={(e) => { e.preventDefault(); this.onClickOption(coupon) }}>
                    <div className="left-side d-flex">
                        <div className="left-rim"></div>
                        <div className="left-content">
                            <div className="desc-1">
                                <div className={`label-coupon ${coupon.image ? "with-brand" : ""}`}>COUPON <span className="with-discount">{coupon.image ? coupon.type === "transport" ? ((coupon.discount_amt >= DELIVERY_COST || coupon.discount_percent === 100) ? 'ฟรีค่าส่ง' : ('ลดค่าส่ง ' + (coupon.discount_percent ? coupon.discount_percent + "%" : coupon.discount_amt + '.-'))) : (coupon.discount_percent ? coupon.discount_percent + "%" : coupon.discount_amt + ".-") : ""}</span></div>
                                {coupon.image
                                    ? <div className="coupon-image"><img src={coupon.image} alt="" /></div>
                                    : <div className={`discount-amt ${coupon.type === "transport" ? "discount-transport" : ""}`}>{coupon.type === "transport" ? ((coupon.discount_amt >= DELIVERY_COST || coupon.discount_percent === 100) ? 'ฟรีค่าส่ง' : ('ลดค่าส่ง ' + (coupon.discount_percent ? coupon.discount_percent + "%" : coupon.discount_amt + '.-'))) : (coupon.discount_percent ? coupon.discount_percent + "%" : coupon.discount_amt + ".-")}</div>
                                }
                                <div className="quantity-limited">คูปองมีจำนวนจำกัด</div>
                            </div>
                            <div className="desc-2">
                                <div className='coupon-expire-date'>หมดอายุ {moment(coupon.end_date).format("DD MMM YYYY")}</div>
                                <div className='coupon-code'>{coupon.promo_code}</div>
                                <div className='coupon-desc'>{coupon.desc}</div>
                                <div className='coupon-min-spend'>ยอดขั้นต่ำ {moneyFormat(coupon.min_spend, '฿')}</div>
                            </div>
                        </div>
                    </div>
                    <div className={`right-side d-flex ${collected ? 'disabled' : ''}`}>
                        <div className="right-content">{this.renderButtonText(coupon)}</div>
                        <div className="right-rim"></div>
                    </div>
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.auth.authenticated,
        profile: state.prof.profile,
        collect_coupon: state.coupon.collect_coupon,
    }
}
export default withRouter(connect(mapStateToProps, { collectCoupon, storeCouponAuth, setCouponListDisplay, swal, close })(CouponCard))